// actions.js
// Action types for jobapply data fetching request, success, and failure
export const FETCH_JOB_APPLY_REQUEST = "FETCH_JOB_APPLY_REQUEST";
export const FETCH_JOB_APPLY_SUCCESS = "FETCH_JOB_APPLY_SUCCESS";
export const FETCH_JOB_APPLY_FAILURE = "FETCH_JOB_APPLY_FAILURE";

// Action creator for jobapply data fetching request
export const fetchJobApplyRequest = (payload) => ({
  type: FETCH_JOB_APPLY_REQUEST,
  payload
});

// Action creator for jobapply data fetching success
export const fetchJobApplySuccess = (isJobApplyItem) => ({
  type: FETCH_JOB_APPLY_SUCCESS,
  payload: isJobApplyItem,
});

// Action creator for jobapply data fetching failure
export const fetchJobApplyFailure = (error) => ({
  type: FETCH_JOB_APPLY_FAILURE,
  payload: error,
});
